// views/staff/staffLang.js
export const messages = {
  en: {
    staff: {
      searchConditions: 'Search Conditions',
      staffName: 'Staff Name',
      phoneNumber: 'Phone Number',
      staffId: 'Staff ID',
      search: 'Search',
      reset: 'Reset',
      staffManagement: 'Staff Management',
      add: 'Add',
      staffNumber: 'Staff Number',
      name: 'Name',
      phone: 'Phone',
      position: 'Position',
      idCard: 'ID Card',
      relatedOrg: 'Related Organization',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      operations: 'Operations',
      edit: 'Edit',
      resetPassword: 'Reset Password',
      delete: 'Delete',
      details: 'Details',
      tips: 'Tip: The default password for newly added staff is 123456. After assigning community permissions and associating roles with staff, they can log in.',
      confirmOperation: 'Please confirm your operation',
      confirmResetPassword: 'Are you sure to reset the password?',
      wrongClick: 'Wrong click',
      confirmReset: 'Confirm Reset',
      modifyStaff: 'Modify Staff',
      requiredName: 'Required, please enter staff name',
      requiredPhone: 'Required, please enter phone number',
      requiredGender: 'Required, please select gender',
      requiredAddress: 'Required, please enter address',
      optionalEmail: 'Optional, please enter email',
      uploadPhoto: 'Upload Photo',
      cancel: 'Cancel',
      confirmDelete: 'Are you sure to delete? Before deleting staff, please confirm that the staff has completed the relevant approval process. After deletion, the relevant process will not be able to continue. Please operate carefully!',
      confirmDeleteAction: 'Confirm Delete',
      relCd: 'Relationship'
    },
    selectStaff: {
      title: 'Select Staff',
      orgInfo: 'Organization Information',
      staffInfo: 'Staff Information',
      submitter: 'Submitter',
      dynamicAssign: 'Dynamic Assignment',
      selectedStaff: 'Selected Staff'
    },
  },
  zh: {
    staff: {
      searchConditions: '查询条件',
      staffName: '员工名称',
      phoneNumber: '手机号',
      staffId: '员工ID',
      search: '查询',
      reset: '重置',
      staffManagement: '员工管理',
      add: '添加',
      staffNumber: '员工编号',
      name: '名称',
      phone: '手机号',
      position: '职位',
      idCard: '身份证',
      relatedOrg: '关联组织',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      male: '男',
      female: '女',
      operations: '操作',
      edit: '修改',
      resetPassword: '重置密码',
      delete: '删除',
      details: '详情',
      tips: '温馨提示：新添加员工默认密码为123456，角色权限分配小区并且角色关联员工后可登录',
      confirmOperation: '请确认您的操作',
      confirmResetPassword: '确认是否重置密码',
      wrongClick: '点错了',
      confirmReset: '确认重置',
      modifyStaff: '修改员工',
      requiredName: '必填，请填写员工名称',
      requiredPhone: '必填，请填写手机号码',
      requiredGender: '必填，请选择员工性别',
      requiredAddress: '必填，请填写家庭住址',
      optionalEmail: '可选，请填写员工名称',
      uploadPhoto: '上传照片',
      cancel: '取消',
      confirmDelete: '确认是否删除，删除员工前请确认员工已完成相关审批流程，删除后相关流程将无法继续进行，请慎重操作！',
      confirmDeleteAction: '确认删除',
      relCd: '岗位'
    },
    selectStaff: {
      title: '选择员工',
      orgInfo: '组织信息',
      staffInfo: '员工信息',
      submitter: '提交者',
      dynamicAssign: '动态指定',
      selectedStaff: '已选员工'
    },
  }
}